import { ArrowLeft16 } from '@ingrid/iconography/react';
import { Link, PreApp } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';
import { AppRoute } from '~src/main/routes';

export function AppLoggedOutPage() {
  const { t } = useTranslation();

  return (
    <PreApp.Wrapper>
      <PreApp.Stack>
        <PreApp.Title>{t('auth.loggedOut.title')}</PreApp.Title>
        <PreApp.Subtitle>{t('auth.loggedOut.text')}</PreApp.Subtitle>

        <Link href={AppRoute.ROOT}>
          <ArrowLeft16 />
          {t('auth.signIn')}
        </Link>
      </PreApp.Stack>
    </PreApp.Wrapper>
  );
}
